export default function ComparisonTable() {
  const rows = [
    { feature: 'Product Discovery', normal: 'Slow searching', superbuy: 'Organized database' },
    { feature: 'Price Comparison', normal: 'Manual research', superbuy: 'Easy comparison' },
    { feature: 'QC Information', normal: 'Limited', superbuy: 'Structured information' },
    { feature: 'Beginner Friendly', normal: 'Medium', superbuy: 'High' },
    { feature: 'Time Saving', normal: 'Low', superbuy: 'High' },
  ];

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-3">
            Superbuy Spreadsheet vs Traditional Shopping
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            See how an organized Superbuy spreadsheet transforms your shopping experience compared to
            browsing manually.
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="py-4 px-6 text-sm font-semibold text-foreground-700">
                    Feature
                  </th>
                  <th className="py-4 px-6 text-sm font-semibold text-foreground-500">
                    Normal Shopping
                  </th>
                  <th className="py-4 px-6 text-sm font-semibold text-primary-600">
                    Superbuy Spreadsheet
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr
                    key={row.feature}
                    className={`border-b border-background-200/40 last:border-0 ${
                      idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                    }`}
                  >
                    <td className="py-4 px-6 text-sm font-medium text-foreground-800">
                      {row.feature}
                    </td>
                    <td className="py-4 px-6 text-sm text-foreground-500">{row.normal}</td>
                    <td className="py-4 px-6">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-primary-600">{row.superbuy}</span>
                        <i className="ri-check-line text-accent-500 text-sm"></i>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}